import React from "react";
import { StyledMDSListBox } from "./select-menu.style";
import { MDSSelectMenuProps } from "./select-menu.types";

export const MDSSelectMenu = React.forwardRef<HTMLDivElement, MDSSelectMenuProps>((props, ref) => {
  return <StyledMDSListBox data-mds-name="select-menu" aria-label="Menu" {...props} ref={ref} />;
});
